import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  CreateTranscriptionTag,
  DeleteTranscriptionTag,
  GetAllTranscriptionTags,
} from "../../services/transcriptionTags";

const initialState = {
  relations: [],
  loading: false,
  error: null,
};

export const getAllTranscriptionTagsAsync = createAsyncThunk(
  "transcriptionTags/getAllTranscriptionTagsAsync",
  async (params) => {
    return await GetAllTranscriptionTags(params);
  }
);

export const createTranscriptionTagAsync = createAsyncThunk(
  "transcriptionTags/createTranscriptionTagAsync",
  async (payload) => {
    return await CreateTranscriptionTag(payload);
  }
);

export const deleteTranscriptionTagAsync = createAsyncThunk(
  "transcriptionTags/deleteTranscriptionTagAsync",
  async (id) => {
    await DeleteTranscriptionTag(id);
    return id;
  }
);

const transcriptionTagSlice = createSlice({
  name: "transcriptionTags",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTranscriptionTagsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTranscriptionTagsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.relations = action.payload;
      })
      .addCase(getAllTranscriptionTagsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createTranscriptionTagAsync.fulfilled, (state, action) => {
        state.relations.push(action.payload);
      })
      .addCase(deleteTranscriptionTagAsync.fulfilled, (state, action) => {
        state.relations = state.relations.filter(
          (relation) => relation.id !== action.payload
        );
      });
  },
});

export default transcriptionTagSlice.reducer;
